import React from "react";
import {
	CustomChips,
	CustomIconButton,
	CustomSwitch,
	CustomTable,
	CustomTableBody,
	CustomTableCell,
	CustomTableHead,
	CustomTableRow,
	icon,
} from "../../../../../common/components";
import { translate, translateDate } from "../../../../../common/providers";
import styles from "./ProjectsListTable.module.css";

const STATUS_CONFIG = {
	ACTIVE: { color: "success", startIcon: icon.faCheckCircle, label: "admin.project-list.status.active" },
	ARCHIVED: { color: "neutral", startIcon: icon.faBoxArchive, label: "admin.project-list.status.archived" },
};

export default function ProjectsListTable({ projects, onChangeArchive, onChangeName, onClickRow, selectedProject }) {
	const tableHeaders = [
		translate("admin.project-list.th.name"),
		translate("admin.project-list.th.status"),
		translate("admin.project-list.th.company-role"),
		translate("admin.project-list.th.creation-date"),
		translate("admin.project-list.th.active"),
	];
	const handleChangeArchive = (project) => {
		onChangeArchive({ project });
	};
	const handleClickRow = (project) => {
		onClickRow?.({ project });
	};
	return (
		<CustomTable stickyHeader>
			<CustomTableHead>
				<CustomTableRow>
					{tableHeaders.map((header) => (
						<CustomTableCell key={header} className={styles.header}>
							{header}
						</CustomTableCell>
					))}
				</CustomTableRow>
			</CustomTableHead>
			<CustomTableBody emptyState={translate("admin.project-list.project")}>
				{Array.isArray(projects) &&
					projects.map((row) => {
						const statusConfig = STATUS_CONFIG[row.currentStatus] || STATUS_CONFIG.ARCHIVED;
						return (
							<CustomTableRow
								key={row.id}
								hover
								className={`${styles.tableRow} ${
									row.currentStatus === "ARCHIVED" ? styles["tableRow--archived"] : ""
								} ${selectedProject?.id === row.id ? styles["tableRow--selected"] : ""}`}
								onClick={() => handleClickRow(row)}
							>
								<CustomTableCell autoTranslate="no" className={`${styles.cell} ${styles.cell__name}`}>
									<span>{row.name}</span>
									<CustomIconButton
										className={styles.renameBtn}
										icon={icon.faPenToSquare}
										size="sm"
										tooltip={translate("admin.project-list.project-rename")}
										variant="text"
										onClick={(e) => {
											e.stopPropagation();
											onChangeName({ project: row });
										}}
									/>
								</CustomTableCell>
								<CustomTableCell className={styles.cell}>
									<CustomChips
										color={statusConfig.color}
										label={translate(statusConfig.label)}
										size="sm"
										startIcon={statusConfig.startIcon}
									/>
								</CustomTableCell>
								<CustomTableCell className={styles.cell}>
									{row.role ? row.role.charAt(0).toUpperCase() + row.role.slice(1).toLowerCase() : ""}
								</CustomTableCell>
								<CustomTableCell className={`${styles.cell} ${styles["cell--secondary"]}`}>
									{translateDate(row.created)}
								</CustomTableCell>
								<CustomTableCell align="right" className={styles.cell__actions}>
									<div role="presentation" onClick={(e) => e.stopPropagation()}>
										<CustomSwitch
											checked={row.currentStatus === "ACTIVE"}
											color="primary"
											size="small"
											onChange={() => handleChangeArchive(row)}
										/>
									</div>
								</CustomTableCell>
							</CustomTableRow>
						);
					})}
			</CustomTableBody>
		</CustomTable>
	);
}
